import styled from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { Facepile as FacepileBase } from '@xing-com/facepile';
import { ProfileImage as ProfileImageBase } from '@xing-com/profile-image';
import {
  spaceS,
  spaceM,
  spaceXXS,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

import { CardElementLink } from './card-element-link';

const Link = styled(CardElementLink)<{ $noMargin?: boolean }>`
  ${({ $noMargin }) => ($noMargin ? '' : `margin-bottom: ${spaceM};`)}
`;

const MemberInfoTitle = styled(Headline)`
  ${lineClamp(2)}
  word-break: break-word;
  margin: 0;
`;

const Label = styled(BodyCopy)`
  ${lineClamp(2)}
  padding-top: ${spaceXXS};
  color: ${xdlColorTextSecondary};
`;

const sharedUserImageStyles = `
  margin-right: ${spaceS};
`;

const ProfileImage = styled(ProfileImageBase)`
  ${sharedUserImageStyles}
`;

// 68px is the height of the profile image, 24px is the margin between the profile image and the title
const Facepile = styled(FacepileBase)`
  top: calc(-1 * (68px + 24px - 14px));
  ${sharedUserImageStyles}
`;

const MemberInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Text = styled(Headline)`
  ${lineClamp(2)}
  word-break: break-word;
  margin: 0 0 ${spaceS} 0;
  height: 60px;
  flex-shrink: 0;
`;

export {
  Link,
  MemberInfoContainer,
  MemberInfoTitle,
  Label,
  ProfileImage,
  Facepile,
  Text,
};
